module.exports = {
    category: {
        myWeeklyPicksException:
            'You have not added your rewards card to your online account. To start earning points online link your card now.',
        myWeeklyPicksExceptionV2:
            'Oops. We can\'t find an Everyday Rewards Card attached to your Woolworths Online account.',
        tokenizedWeeklyPicksExceptionMessage:
            'Please give us a second chance and hit \'reload page\' to see them.',
        disableCategoryMenuHover: false,
        excludeSpecials: false,
        myWeeklyPicksExceptionRewards:
            'To see your favourites and start collecting points, please use the button below to add your Everyday Rewards Cards.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/category.js